<template>
  <button
    class="filterAZ"
    :class="{
      active: $route.query.sort_param === sortAz || !$route.query.sort_param,
      desc: $route.query.sort_value === 'desc',
    }"
    @click="
      $routerPushQuerySort(
        sortAz,
        !$route.query.sort_value || $route.query.sort_value === 'asc' ? 'desc' : 'asc',
      )
    "
  >
    <div class="filterAZ_letters">
      <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.14964 0H2.96332L0.0584717 8.29949H1.70976L2.14617 7.05262H4.93406L5.36421 8.29949H7.01293L4.14964 0ZM2.69167 5.49402L3.55011 3.04125L4.39636 5.49402H2.69167Z"
          fill="#277FAF"
        />
      </svg>
      <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.11109 0.689453H0.0195312V2.24805H4.76719L0.0195312 7.76465V8.98906H7.03316V7.43047H2.36344L7.11109 1.91387V0.689453Z"
          fill="#277FAF"
        />
      </svg>
    </div>
    <svg
      class="filterAZ_arrow"
      width="10"
      height="20"
      viewBox="0 0 10 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.87836 14.0552L5.91704 17.0166V0H4.35844V17.0166L1.39711 14.0552L0.295044 15.1573L5.13774 20L9.98044 15.1573L8.87836 14.0552Z"
        fill="#277FAF"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'ButtonFilterAZ',
  props: { sortAz: String },
  methods: {
    pushParams(parameter) {
      let query = Object.assign({}, this.$route.query)
      query['style_list'] = parameter
      this.$router.push({ query })
    },
  },
}
</script>

<style lang="scss" scoped>
.filterAZ {
  display: grid;
  padding: 5px;
  grid-template-columns: max-content max-content;
  gap: 3px;
  background: #bdbdbd;
  border-radius: 10px;
  align-items: center;
  height: max-content;
  width: max-content;
  height: max-content;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 10px;
  svg {
    path {
      fill: #ffffff;
    }
  }

  &.active {
    background: #ffffff;
    svg {
      path {
        fill: #277faf;
      }
    }
  }
  &_letters {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }
  &.desc {
    .filterAZ_arrow {
      transform: rotate(180deg);
    }
  }
}
</style>
